import GettingStarted from "../../../../ambassador-docs/docs/1.7/tutorials/GettingStarted";
import * as React from 'react';
export default {
  GettingStarted,
  React
};